import { bool, node } from "prop-types";

import styled from "styled-components/macro";
import { opacity } from "theme";

const OpacityRelay = styled("div")`
  ${opacity}
`;

/**
 * A container used to toggle from visible to not visible without changing the dom layout. Also disables click action when not visible.
 * @param {object} param0
 * @param {boolean} param0.show - should the contained element be shown?
 * @param {boolean} param0.scale - scales the content as it fades.
 * @returns
 */
const FnrOpacityToggle = ({ show, children, scale, ...rest }) => {
  return (
    <OpacityRelay $variant={show ? "shown" : "hidden"} $scale={scale} {...rest}>
      {children}
    </OpacityRelay>
  );
};

FnrOpacityToggle.propTypes = { show: bool, scale: bool, children: node };

export default FnrOpacityToggle;
